import {
  formatCurrency,
  type IParsedNotificationData,
  type IParsedNotificationDataProps,
} from '@repo/sdk'
import { Button } from '@repo/ui'
import Link from 'next/link'
import React from 'react'

export const parseNotificationData = ({
  notification,
}: IParsedNotificationDataProps): IParsedNotificationData | undefined => {
  switch (notification.type) {
    case 'bidding.finished':
      return {
        borderLeftColor: 'orange.500',
        buttons: (
          <Button asChild className={'h-8 w-24 text-sm font-medium'} variant="outline">
            <Link href={`/shipments/${notification.load.load_id}`}>View</Link>
          </Button>
        ),
        text: (
          <div className={'flex'}>
            Your quote
            <p className={'mx-2 font-bold'}>{notification.load.load_id}</p>
            has been confirmed
          </div>
        ),
        ...notification,
        load: notification?.load?.data || notification?.load,
      }
    case 'inquiry-load-confirmation':
      return {
        borderLeftColor: 'green.500',
        buttons: (
          <div className={'flex gap-2'}>
            <Button asChild className={'h-10'} variant="outline">
              <Link href={`/shipments/${notification.load.load_id}`}>View</Link>
            </Button>
          </div>
        ),
        text: <div className={'flex'}>Quote confirmed for {notification.load.load_id}</div>,
        ...notification,
      }
    case 'inquiry-load-new-admin-bid':
      return {
        borderLeftColor: 'orange.500',
        // Buttons: (
        //   <div className="flex gap-2">
        //     <Button
        //       height={'40px'}
        //       onClick={() => {
        //         navigate?.(`/quotes/${notification.load.quote_id}`);
        //       }}
        //       variant={'outline'}>
        //       View
        //     </Button>
        //   </div>
        // ),
        text: (
          <div className={'flex'}>
            KCharles offers
            <p className={'mx-2 font-bold'}>£{formatCurrency(notification.load.rate)}</p>
            for {notification.load.load_id}
          </div>
        ),
        ...notification,
      }
    case 'inquiry-load-status-updated':
      return {
        borderLeftColor: 'blue.600',
        text: (
          <div className={'flex'}>
            <p className={'mr-2 font-bold'}>Inquiry status</p>
            has been updated for {notification.load.load_id} to{' '}
            {notification.load.inquiry_load_status?.title}
          </div>
        ),
        ...notification,
      }
    case 'load-document-uploaded':
      return {
        borderLeftColor: 'blue.500',
        buttons: (
          <Button asChild className={'h-8 w-24 text-sm font-medium'} variant="outline">
            <Link href={`/shipments/${notification.load.load_id}`}>View</Link>
          </Button>
        ),
        text: (
          <div className={'flex'}>
            <p className={'mr-2 font-bold'}>Documents</p>
            has been uploaded for {notification.load.load_id}
          </div>
        ),
        ...notification,
      }
    case 'new-inquiry-load':
      return {
        borderLeftColor: 'yellow.400',
        text: 'New inquiry',
        ...notification,
      }
    default:
      return undefined
  }
}
